import * as React from 'react'
import { connect } from 'react-redux'
import * as MediaActions from '@disco/state-management/actions/MediaActions'
import {
  getTrackPlaybackStatus,
  getTrackPlaying,
} from '@disco/state-management/selectors/media'
import PlaybackManager from 'components/common/player/playback-manager/loader'
const defaultStatus = {}

function mapStateToProps(state) {
  const track = getTrackPlaying(state)
  const status = track
    ? getTrackPlaybackStatus(state, {
        trackId: track.id,
      })
    : defaultStatus
  return { ...status, track: track, volume: state.media.volume }
}

const mapDispatchToProps = MediaActions

const PlayerContainer = props => {
  if (!props.track) return null
  return <PlaybackManager {...props} />
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlayerContainer) as any
